var _polygon, _rect, _rect2, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawTipImage9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "af68f4ca-3b92-43b5-826f-d4785abba14f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 657.07521,
    height: 782.11023,
    viewBox: "0 0 657.07521 782.11023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Employee voice feedback tip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "656.693 776.134 398.955 776.134 398.955 774.028 657.075 774.028 656.693 776.134",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 489.83141,
    y: 734.87219,
    width: 14,
    height: 30,
    fill: "#fbbebe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 598.83141,
    y: 735.87219,
    width: 14,
    height: 30,
    fill: "#fbbebe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M885.7938,809.31707l-17-2-44-203-48,204-17-2c-2.80505-92.30676,5.393-184.65051,12.5-261.5l101.5-8.5C892.91764,612.04467,893.702,706.292,885.7938,809.31707Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M875.23793,548.3272s-23.64072,24.66859-10.27856,30.83575,21.585-27.75217,21.585-27.75217Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#fbbebe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M754.23793,550.3272s-23.64072,24.66859-10.27856,30.83575,21.585-27.75217,21.585-27.75217Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#fbbebe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 554.83141,
    cy: 284.87219,
    r: 28,
    fill: "#fbbebe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M858.7938,402.31707l-50,5c4.62165-20.80514,5.74189-40.24267,0-57h35C841.89244,364.28042,848.99925,382.64248,858.7938,402.31707Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#fbbebe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7938,547.31707c-18.68261,22.47339-57.94348,14.9596-103-1,12.7854-41.7333,10.80293-85.763-.686-131.271a10.70062,10.70062,0,0,1,5.99935-12.42383l36.68667-16.30519,14,3,24-6,34.06789,6.96844a11.82588,11.82588,0,0,1,9.43916,12.18426C890.45152,458.32656,885.41093,510.01971,872.7938,547.31707Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M882.7938,565.31707l-9-15,17-64-9-96h0a27.50644,27.50644,0,0,1,24.17076,21.66224l13.65363,64.36709a44.59369,44.59369,0,0,1-3.51068,28.73652Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M765.7938,554.31707l-20.5,3.5,13.07213-127.96361a32.5071,32.5071,0,0,1,20.42785-29.53638h0l6.5,84.5Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M769.97047,834.301,732.237,840.92827a8.4137,8.4137,0,0,1-5.04863-.679h0a8.41371,8.41371,0,0,1-2.12088-13.78363L741.2315,811.51l4.21406-7.36421a14.88626,14.88626,0,0,1,11.74751-7.6c7.20622-.49958,9.58471,4.98389,8.078,15.28207,5.47321,4.0261,6.33836,3.40769,10.02277-2.01077l1.6723,16.97618A8.51374,8.51374,0,0,1,769.97047,834.301Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M878.97047,834.301,841.237,840.92827a8.4137,8.4137,0,0,1-5.04863-.679h0a8.41371,8.41371,0,0,1-2.12088-13.78363L850.2315,811.51l4.21406-7.36421a14.88626,14.88626,0,0,1,11.74751-7.6c7.20622-.49958,9.58471,4.98389,8.078,15.28207,5.47321,4.0261,6.33836,3.40769,10.02277-2.01077l1.6723,16.97618A8.51374,8.51374,0,0,1,878.97047,834.301Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M804.06349,327.86329c12.62069-7.22064,25.25839-2.60733,37.918,17.09452l2.58817,20.98707c19-18,18.03949-42.56432-3.26774-52.55533-2.09476-.98221-4.12469-2.09934-6.40432-1.70456a20.07533,20.07533,0,0,0-26.5738,7.13878c-3.93662.68174-9.58015,8.50276-9.37705,12.49284Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 569.33141,
    cy: 286.37219,
    rx: 3.5,
    ry: 4.5,
    fill: "#fbbebe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.40488,500h58.26667a0,0,0,0,1,0,0v0a23,23,0,0,1-23,23H174.40486a23,23,0,0,1-23-23v0A0,0,0,0,1,151.40488,500Z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M494.74818,507.44993V486.0762c0-25.8266,28.08866-50.255,46.30976-67.68351,25.6841-24.55308,39.18519-57.53988,39.18519-96.18181a128.24342,128.24342,0,0,0-256.48485-.71346q-.001.35675,0,.71346c0,37.26154,14.07994,72.4837,39.18518,96.18181,18.12316,17.10789,46.30977,41.58975,46.30977,67.68351v21.37373",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#4cbabb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M494.74841,510.44977a2.99984,2.99984,0,0,1-3-3v-21.374c0-25.125,24.77929-48.58008,42.87256-65.706,1.50146-1.42188,2.96142-2.80371,4.36328-4.14453,25.02929-23.92774,38.25879-56.437,38.25879-94.01416,0-70.2295-55.0127-125.24268-125.24219-125.24268-.11768-.00049-.23584-.00049-.35352-.00049A125.03047,125.03047,0,0,0,326.75817,321.50592v.69873c0,36.80176,13.93946,71.06347,38.24463,94.00683,1.23145,1.16309,2.51026,2.36036,3.82324,3.58887,18.32715,17.15918,43.42725,40.6582,43.42725,66.27539v21.374a3,3,0,1,1-6,0v-21.374c0-23.01465-24.00244-45.48633-41.52783-61.89551-1.31934-1.23437-2.604-2.4375-3.84131-3.60546-25.50049-24.07227-40.126-59.92432-40.126-98.36377v-.71973c.20118-72.04492,58.88477-130.52344,130.88037-130.52344.12793,0,.24317,0,.37061.00049A130.55722,130.55722,0,0,1,583.243,322.211c0,39.25488-13.87061,73.26416-40.11182,98.35107-1.40869,1.34668-2.87646,2.73633-4.38574,4.165-17.30176,16.377-40.99707,38.80566-40.99707,61.34863v21.374A2.99984,2.99984,0,0,1,494.74841,510.44977Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480.4989,548.94488H423.50231a5,5,0,0,1,0-10H480.4989a5,5,0,1,1,0,10Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#4cbabb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M319.39929,204.35064a4.97979,4.97979,0,0,1-3.28614-1.23339l-42.939-37.48145a4.99988,4.99988,0,1,1,6.57617-7.5332l42.939,37.48144a5,5,0,0,1-3.29,8.7666Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M577.4779,204.35064a5,5,0,0,1-3.29-8.7666l42.93848-37.48144a4.99988,4.99988,0,0,1,6.57617,7.5332L580.764,203.11725A4.97976,4.97976,0,0,1,577.4779,204.35064Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M494.74841,531.19781H409.25329a5,5,0,0,1,0-10h85.49512a5,5,0,1,1,0,10Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#4cbabb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M452.00085,512.44977a4.99994,4.99994,0,0,1-5-5V393.4566a5,5,0,0,1,10,0V507.44977A4.99994,4.99994,0,0,1,452.00085,512.44977Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M452.00085,398.4566c-16.15527,0-35.98975-14.61523-36.82617-15.2373a5,5,0,1,1,5.96875-8.02344c4.96924,3.687,20.20508,13.26074,30.85742,13.26074s25.88818-9.57373,30.85986-13.26269a5.00009,5.00009,0,0,1,5.96631,8.02539C487.9906,383.84137,468.15612,398.4566,452.00085,398.4566Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M452.00036,154.44a5.00025,5.00025,0,0,1-5-5V63.94488a5,5,0,0,1,10,0V149.44A5.00025,5.00025,0,0,1,452.00036,154.44Z",
    transform: "translate(-271.4624 -58.94488)",
    fill: "#e6e6e6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTipImage9);
export default __webpack_public_path__ + "static/media/undraw-tip-image-9.516a255f9a2cb2d1c52d92869fa9d9f5.svg";
export { ForwardRef as ReactComponent };